/**
 * Bootstrap webcomponents.js (v1 spec polyfills)
 */
import '@webcomponents/webcomponentsjs/webcomponents-lite'
import '@webcomponents/webcomponentsjs/custom-elements-es5-adapter'



// WEBPACK FOOTER //
// ./assets/scripts/webcomponents.ts